const CLASH_THRESHOLD = 100;

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}

export function resolveAwayColor(localColor, awayColor, awayAltColor) {
  const [r1, g1, b1] = hexToRgb(localColor);
  const [r2, g2, b2] = hexToRgb(awayColor);
  const dist = Math.sqrt((r1 - r2) ** 2 + (g1 - g2) ** 2 + (b1 - b2) ** 2);
  return dist < CLASH_THRESHOLD ? awayAltColor : awayColor;
}
